import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  program: {},
  programs: [],
  overviewLoader: false,
  programsLoading: false,
  programLoading: false,
  programsPagination: {},
  reportLoading: false,
  report: "",
  programConfirmReportLoading: false,
  programConfirmedReport: null,
});

export default function programReducer(state = initialState, action) {
  switch (action.type) {
    // GET PROGRAMS
    case ACTIONS.PROGRAMS.PENDING: {
      return state.set("error", "").set("programsLoading", true);
    }
    case ACTIONS.PROGRAMS.SUCCESS: {
      return state
        .set("error", "")
        .set("programs", action.data.data)
        .set("programsPagination", action.data.pagination)
        .set("programsLoading", false);
    }
    case ACTIONS.PROGRAMS.ERROR: {
      return state.set("error", action.error).set("programsLoading", false);
    }

    // SORT PROGRAMS
    case ACTIONS.SORT_PROGRAMS.PENDING: {
      return state.set("error", "").set("programsLoading", true);
    }
    case ACTIONS.SORT_PROGRAMS.SUCCESS: {
      return state
        .set("error", "")
        .set("programs", action.data.data)
        .set("programsPagination", action.data.pagination)
        .set("programsLoading", false);
    }
    case ACTIONS.SORT_PROGRAMS.ERROR: {
      return state.set("error", action.error).set("programsLoading", false);
    }

    // CREATE PROGRAM
    case ACTIONS.CREATE_PROGRAMS.PENDING: {
      return state.set("error", "").set("programLoading", true);
    }
    case ACTIONS.CREATE_PROGRAMS.SUCCESS: {
      return state
        .set("error", "")
        .set("programLoading", false)
        .set("programs", action.data.data)
        .set("programsPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_PROGRAMS.ERROR: {
      return state.set("error", action.error).set("programLoading", false);
    }

    // UPDATE PROGRAM
    case ACTIONS.UPDATE_PROGRAMS.PENDING: {
      return state.set("error", "").set("programLoading", true);
    }
    case ACTIONS.UPDATE_PROGRAMS.SUCCESS: {
      if (action.data.type === "overview") {
        return state
          .set("error", "")
          .set("programLoading", false)
          .set("program", action.data.data);
      } else {
        return state
          .set("error", "")
          .set("programLoading", false)
          .set("programs", action.data.data)
          .set("programsPagination", action.data.pagination);
      }
    }
    case ACTIONS.UPDATE_PROGRAMS.ERROR: {
      return state.set("error", action.error).set("programLoading", false);
    }

    // DELETE PROGRAM
    case ACTIONS.DELETE_PROGRAMS.PENDING: {
      return state.set("error", "").set("programLoading", true);
    }
    case ACTIONS.DELETE_PROGRAMS.SUCCESS: {
      return state
        .set("error", "")
        .set("programLoading", false)
        .set("programs", action.data.data)
        .set("programsPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_PROGRAMS.ERROR: {
      return state.set("error", action.error).set("programLoading", false);
    }

    // GET PROGRAM DETAILS
    case ACTIONS.GET_PROGRAM_DETAILS.PENDING: {
      return state
        .set("error", "")
        .set("programLoading", true)
        .set("overviewLoader", true);
    }
    case ACTIONS.GET_PROGRAM_DETAILS.SUCCESS: {
      return state
        .set("error", "")
        .set("programLoading", false)
        .set("overviewLoader", false)
        .set("program", action.data);
    }
    case ACTIONS.GET_PROGRAM_DETAILS.ERROR: {
      return state
        .set("error", action.error)
        .set("programLoading", false)
        .set("overviewLoader", false);
    }

    // GET PROGRAM BUDGET SUMMARY
    case ACTIONS.GET_PROGRAM_BUDGET_SUMMARY.PENDING: {
      return state.set("error", "").set("programBudgetSummaryLoading", true);
    }
    case ACTIONS.GET_PROGRAM_BUDGET_SUMMARY.SUCCESS: {
      return state
        .set("programBudgetSummaryLoading", false)
        .set("error", "")
        .set("programBudgetSummary", action.data);
    }
    case ACTIONS.GET_PROGRAM_BUDGET_SUMMARY.ERROR: {
      return state
        .set("programBudgetSummaryLoading", false)
        .set("error", action.error);
    }
    // GET PROGRAM PROGRESS SUMMARY
    case ACTIONS.GET_PROGRAM_PROGRESS_SUMMARY.PENDING: {
      return state.set("error", "").set("programProgressSummaryLoading", true);
    }
    case ACTIONS.GET_PROGRAM_PROGRESS_SUMMARY.SUCCESS: {
      return state
        .set("programProgressSummaryLoading", false)
        .set("error", "")
        .set("programProgressSummary", action.data);
    }
    case ACTIONS.GET_PROGRAM_PROGRESS_SUMMARY.ERROR: {
      return state
        .set("programProgressSummaryLoading", false)
        .set("error", action.error);
    }
    ////////////////////////////////////// HEALTH STATUS //////////////////////////////////////

    // GET Progress Tracker
    case ACTIONS.PROGRESS_TRACKER.PENDING: {
      return state.set("error", "").set("progressTrackerLoading", true);
    }

    case ACTIONS.PROGRESS_TRACKER.SUCCESS: {
      return state.set("error", "").set("progressTrackerLoading", false).set("progressTracker", action.data);
    }

    case ACTIONS.PROGRESS_TRACKER.ERROR: {
      return state.set("error", action.error).set("progressTrackerLoading", false);
    }

    case ACTIONS.PROGRESS_TRACKER_FILTER.PENDING: {
      return state.set("error", "").set("progressTrackerLoading", true);
    }

    case ACTIONS.PROGRESS_TRACKER_FILTER.SUCCESS: {
      return state.set("error", "").set("progressTrackerLoading", false).set("progressTracker", action.data);
    }

    case ACTIONS.PROGRESS_TRACKER_FILTER.ERROR: {
      return state.set("error", action.error).set("progressTrackerLoading", false);
    }

    // UPDATE PROGRESS KPI

    case ACTIONS.UPDATE_PROGRESS_KPI.PENDING: {
      return state.set("error", "");
    }

    case ACTIONS.UPDATE_PROGRESS_KPI.SUCCESS: {
      return state.set("error", "");
    }

    case ACTIONS.UPDATE_PROGRESS_KPI.ERROR: {
      return state.set("error", action.error);
    }
    ////////////////////////////////////// STATUS REPORT //////////////////////////////////////

    case ACTIONS.PROGRAM_STATUS_REPORT.PENDING: {
      return state.set("error", "").set("programReportLoading", true);
    }
    case ACTIONS.PROGRAM_STATUS_REPORT.SUCCESS: {
      return state
        .set("programReportLoading", false)
        .set("error", "")
        .set("programReport", action.data);
    }
    case ACTIONS.PROGRAM_STATUS_REPORT.ERROR: {
      return state.set("programReportLoading", false).set("error", action.error);
    }

    case ACTIONS.PROGRAM_CLEAR_STATUS_REPORT: {
      return state.set("programReport", "");
    }

    case ACTIONS.PROGRAM_CONFIRM_WSR_REPORT.PENDING: {
      return state.set("error", "").set("programConfirmReportLoading", true);
    }
    case ACTIONS.PROGRAM_CONFIRM_WSR_REPORT.SUCCESS: {
      return state
        .set("programConfirmReportLoading", false)
        .set("error", "")
        .set("programConfirmedReport", action.data);
    }
    case ACTIONS.PROGRAM_CONFIRM_WSR_REPORT.ERROR: {
      return state.set("programConfirmReportLoading", false).set("error", action.error);
    }

    default: {
      return state;
    }
  }
}
